module.exports = __webpack_public_path__ + "img/img_left_nav_money.02aa2419.svg";